// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__joZyM","modal":"Modal_modal__YoeMU","slide-down":"Modal_slide-down__9NwjZ"};